import { CicloI } from "interfaces/Ciclo";

export interface infoFecthCicloI {
  id: number | string;
  nombre: string;
  descripcion: string;
  anioInicial: number | string;
  anioFinal: number | string;
}

class Ciclo implements CicloI {
  id: number | string;
  nombre: string;
  descripcion: string;
  anioInicial: number | string;
  anioFinal: number | string;

  constructor(infoFetch: infoFecthCicloI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.descripcion = infoFetch.descripcion;
    this.anioInicial = infoFetch.anioInicial;
    this.anioFinal = infoFetch.anioFinal;
  }
}

export const makeCiclo = (infoFetch: infoFecthCicloI) => {
  return new Ciclo(infoFetch);
};
